/* collins-shell.js: the shared header and the full-screen menu (COLLINS.md: Header, Menu). No library.
   The header hides on the way down and returns on any scroll up (the CSS carries COLLINS's 450 ms ease-out cubic).
   The menu is a dialog: it traps focus, closes on Escape, a link or the button, and gives focus back.
   Everything is torn down and rebuilt when the theme editor reloads the header section. */
(function () {
  'use strict';
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var head = null, btn = null, menu = null, headH = 74, lastY = 0, ticking = false, open = false, closeTimer = 0;

  function update() {
    ticking = false;
    if (!head || open) return;
    var y = Math.max(0, w.scrollY || 0);
    head.classList.toggle('is-away', y > 4);   /* away from the top it carries the ground, so nothing collides under it */
    if (y <= 4) head.classList.remove('is-hidden');
    else if (y > lastY + 2 && y > headH) head.classList.add('is-hidden');
    else if (y < lastY - 2) head.classList.remove('is-hidden');
    lastY = y;
  }
  function onScroll() { if (!ticking) { ticking = true; w.requestAnimationFrame(update); } }

  function focusables() {
    return [btn].concat(Array.prototype.slice.call(menu.querySelectorAll('a[href], button:not([disabled])')));
  }
  function setMenu(next) {
    if (!menu || next === open) return;
    open = next;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Close the menu' : 'Open the menu');
    w.clearTimeout(closeTimer);
    if (open) {
      menu.hidden = false;
      de.classList.add('cl-menu-open');
      head.classList.remove('is-hidden');
      w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { menu.classList.add('is-open'); }); });
      var first = menu.querySelector('a[href]');
      if (first) first.focus({ preventScroll: true });
    } else {
      menu.classList.remove('is-open');
      de.classList.remove('cl-menu-open');
      closeTimer = w.setTimeout(function () { if (!open) menu.hidden = true; }, reduce ? 0 : 360);
      btn.focus({ preventScroll: true });
    }
  }
  function onResize() { if (head) headH = head.offsetHeight; }
  function onClick() { setMenu(!open); }
  function onMenuClick(e) { if (e.target.closest && e.target.closest('a[href]')) setMenu(false); }
  function onKey(e) {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); setMenu(false); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(), i = f.indexOf(d.activeElement);
    if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
  }

  function init() {
    head = d.querySelector('[data-cl-head]');
    btn = d.querySelector('[data-cl-menu-btn]');
    menu = d.getElementById('cl-menu');
    if (!head) return;
    headH = head.offsetHeight;                 /* measured once (and on resize), never inside the scroll frame */
    lastY = w.scrollY || 0;
    update();
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onResize);
    if (btn && menu) {
      btn.addEventListener('click', onClick);
      menu.addEventListener('click', onMenuClick);
      d.addEventListener('keydown', onKey);
    }
  }
  function destroy() {
    w.removeEventListener('scroll', onScroll);
    w.removeEventListener('resize', onResize);
    if (btn) btn.removeEventListener('click', onClick);
    if (menu) menu.removeEventListener('click', onMenuClick);
    d.removeEventListener('keydown', onKey);
    w.clearTimeout(closeTimer);
    de.classList.remove('cl-menu-open');
    open = false; head = btn = menu = null;
  }

  var isHeader = function (e) { return e.target && e.target.id === 'shopify-section-header'; };
  d.addEventListener('shopify:section:unload', function (e) { if (isHeader(e)) destroy(); });
  d.addEventListener('shopify:section:load', function (e) { if (isHeader(e)) { destroy(); init(); } });
  w.addEventListener('pageshow', function (e) { if (e.persisted) { destroy(); init(); } });
  init();
})();
